<div class="offline-screen">
  <img class="brand" src="/assets/img/streakers/logo-white.png" alt="Holiday Streakers">
  <div class="offline-content">
    <svg class="streaker-scene" viewBox="0 0 400 280" aria-hidden="true" focusable="false">
      <circle cx="200" cy="140" r="112" fill="#ffffff" fill-opacity=".05"/>
      <path d="M38 231 Q200 216 362 231" fill="none" stroke="#eee7d7" stroke-width="3"/>
      <g fill="#e5a000"><path d="m76 60 3 8 9 1-7 6 2 9-7-5-8 5 2-9-7-6 10-1z"/><circle cx="322" cy="97" r="3"/><circle cx="113" cy="121" r="3"/></g>
      <g class="runner" stroke-linecap="round" stroke-linejoin="round">
        <path d="m193 149-28 39-38 8m70-41 25 31 40 17" fill="none" stroke="#fff8e7" stroke-width="15"/>
        <path d="m198 114-12 40" stroke="#bf1e2e" stroke-width="29"/>
        <path d="m194 122-29 18-24-15m62-2 27 16 24-27" fill="none" stroke="#fff8e7" stroke-width="12"/>
        <circle cx="211" cy="90" r="18" fill="#fff8e7" stroke="none"/>
        <path d="m193 79 11-30 25 29" fill="#bf1e2e" stroke="none"/>
        <path d="m193 79 36-1" stroke="#fff8e7" stroke-width="8"/>
        <circle cx="204" cy="49" r="7" fill="#fff8e7" stroke="none"/>
        <path d="m194 111-28-4-20 10" fill="none" stroke="#e5a000" stroke-width="8"/>
      </g>
      <g class="trail" stroke="#e5a000" stroke-width="3" stroke-linecap="round"><path d="M82 161h39M65 178h32M88 195h20"/></g>
      <path d="m301 162-17 30h10l-19 26h51l-19-26h10z" fill="#6ea42b"/>
      <path d="M301 219v10" stroke="#eee7d7" stroke-width="4"/>
    </svg>
    <div role="status" aria-live="polite">
      <p class="eyebrow">A little detour</p>
      <h1>Our connection took a cocoa break.</h1>
      <p class="explanation">We can’t reach Holiday Streakers right now.<br>We’ll reconnect automatically when it’s back.</p>
    </div>
    <button #retryButton type="button" (click)="retry()">Try again</button>
    <p class="footnote">You can keep moving. We’ll handle the reconnecting.</p>
  </div>
</div>
